<template>
    <div class="table">
        <div class="container">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList('search')">
                <el-form-item label="订单号">
                    <el-input v-model="dataForm.orderNo" placeholder="请输入订单号" clearable></el-input>
                </el-form-item>
                <el-form-item label="客户姓名">
                    <el-input v-model="dataForm.cusName" placeholder="请输入客户姓名" clearable></el-input>
                </el-form-item>
                <el-form-item label="客户电话">
                    <el-input v-model="dataForm.cusPhone" placeholder="请输入客户电话" clearable></el-input>
                </el-form-item>
                <el-form-item label="小区地址">
                    <el-input v-model="dataForm.cusAddress" placeholder="请输入小区地址" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList('search')"
                               icon="el-icon-search">查询
                    </el-button>
                    <el-button type="primary" @click="addOrUpdateHandle()"
                               v-if="isAuth('order-add')">新增
                    </el-button>
                    <el-button type="danger" @click="deleteHandle()"
                               v-if="isAuth('order-delete')"
                               :disabled="dataListSelections.length <= 0">批量删除
                    </el-button>
                </el-form-item>
            </el-form>
            <el-table
                    :data="dataList"
                    border
                    v-loading="dataListLoading"
                    @selection-change="selectionChangeHandle"
                    style="width: 100%;">
                <el-table-column
                        type="selection"
                        header-align="center"
                        align="center"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="orderNo"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="订单号">
                </el-table-column>
                <el-table-column
                        prop="cusName"
                        header-align="center"
                        align="center"
                        width="100"
                        :show-overflow-tooltip="true"
                        label="客户姓名">
                </el-table-column>
                <el-table-column
                        prop="cusPhone"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="联系电话">
                </el-table-column>
                <el-table-column
                        prop="orderType"
                        header-align="center"
                        align="center"
                        width="100"
                        :show-overflow-tooltip="true"
                        label="订单类型">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.orderType===1" type="success">装修</el-tag>
                        <el-tag v-if="scope.row.orderType===2" type="warning">兔狗</el-tag>
                        <el-tag v-if="scope.row.orderType===3">销售</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="names"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="服务人员">
                </el-table-column>
                <el-table-column
                        prop="status"
                        header-align="center"
                        align="center"
                        width="100"
                        :show-overflow-tooltip="true"
                        label="状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status===1" type="warning">定金</el-tag>
                        <el-tag v-if="scope.row.status===2" type="success">80%货款</el-tag>
                        <el-tag v-if="scope.row.status===3">尾款</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="deliveryDate"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="配送时间">
                </el-table-column>
                <el-table-column
                        prop="creationDate"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="创建时间">
                </el-table-column>
                <el-table-column
                        prop="remarks"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="备注">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        header-align="center"
                        align="center"
                        width="150"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini"
                                   v-if="isAuth('order-edit')"
                                   @click="addOrUpdateHandle(scope.row.id)">编辑
                        </el-button>
                        <el-button type="danger" size="mini"
                                   v-if="isAuth('order-delete')"
                                   @click="deleteHandle(scope.row.id)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    @size-change="sizeChangeHandle"
                    @current-change="currentChangeHandle"
                    :current-page="pageIndex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    :total="totalPage"
                    layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <order-add-or-update v-if="addOrUpdateVisible" ref="order"
                             @getDataList="getDataList()"></order-add-or-update>
    </div>
</template>

<script>
    import {Order} from "../../api/order";
    import OrderAddOrUpdate from "./order-add-or-update";

    export default {
        name: 'order',
        data() {
            return {
                dataForm: {
                    orderNo: '',
                    cusName: '',
                    cusPhone: '',
                    cusAddress: ''
                },
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false
            }
        },
        components: {
            OrderAddOrUpdate
        },
        created() {
            this.getDataList();
        },
        activated() {
            this.getDataList();
        },
        computed: {},
        methods: {
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getDataList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getDataList();
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val;
            },
            /**
             * 获取数据
             */
            getDataList(type) {
                this.dataListLoading = true;
                if (type === 'search') {
                    this.pageIndex = 1;
                }
                let params = {
                    'pageIndex': this.pageIndex,
                    'limit': this.pageSize,
                    'orderNo': this.dataForm.orderNo,
                    'cusName': this.dataForm.cusName,
                    'cusPhone': this.dataForm.cusPhone,
                    'cusAddress': this.dataForm.cusAddress
                };
                Order.getOrderList(params).then(res => {
                    if (res.code === 0) {
                        this.dataList = res.page.list;
                        this.totalPage = res.page.totalCount;
                    }
                    this.dataListLoading = false;
                });
            },
            /**
             * 添加或编辑
             * @param id
             */
            addOrUpdateHandle(id) {
                this.addOrUpdateVisible = true;
                this.$nextTick(() => {
                    this.$refs.order.init(id)
                })
            },
            /**
             * 删除
             */
            deleteHandle(id) {
                let ids = id ? id.toString() : this.dataListSelections.map(item => item.id).join();
                //console.log(ids)
                let arrayIds = {'ids': ids};
                this.$confirm('确定删除订单信息吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    Order.deleteOrder(arrayIds).then(res => {
                        if (res.code === 0) {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.$nextTick(() => {
                                        this.getDataList();
                                    })
                                }
                            })
                        }
                    })
                }).catch(() => {
                })
            }
        }
    }

</script>

<style scoped>

</style>
